/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Schedules_Awaiting_Approval_BlockedInputs */



/**
* | output |
* | --- |
* | "Paused: {count} runs awaiting approval" |
*
* @param {Agent_Schedules_Awaiting_Approval_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedules_awaiting_approval_blocked = /** @type {((inputs: Agent_Schedules_Awaiting_Approval_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedules_Awaiting_Approval_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Angehalten: ${i?.count} Läufe warten auf Freigabe`)
	return /** @type {LocalizedString} */ (`Paused: ${i?.count} runs awaiting approval`)
});